import {FC} from 'react'

import cn from 'classnames/bind'

import LandingsTitle from 'components/blocks/LandingsTitle'
import PortableBlocks from 'components/blocks/PortableBlocks'
import {Container} from 'components/elements/grid'
import {IW2Content} from 'pages/make-your-w2'

import s from './W2TipsWhenLosing.module.scss'
const cx = cn.bind(s)

interface IW2TipsWhenLosingProps {
	className?: string
	content: IW2Content['tipsWhenLosing']
}

/** W2TipsWhenLosing block component */
const W2TipsWhenLosing: FC<IW2TipsWhenLosingProps> = ({className, content}) => {
	return (
		<div className={cx('wrapper', className)}>
			<Container>
				<LandingsTitle className={s.title} title={content?.title} />
				{content?.content && <PortableBlocks blockContent={content?.content} />}
			</Container>
		</div>
	)
}

W2TipsWhenLosing.displayName = 'W2TipsWhenLosing'

export default W2TipsWhenLosing
